// extracted by mini-css-extract-plugin
export default {"categoriesContainer":"CategoriesWithTitles_categoriesContainer__0DXOS"};